import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores/auth';
import { useProfilePreview } from '../../lib/profilePreview';
import { canOpenProfileRoute, userLanding } from '../../lib/profileAccess';
export function NoAccessPage() {
  return <section role="alert" className="mx-auto max-w-xl p-8"><h1 className="text-2xl font-semibold">No access</h1><p className="mt-2">Your profile cannot open this page.</p><a href="/">Go to your home</a></section>;
}
export function ProfileRouteGuard({ children }: { children: ReactNode }) {
  const { user, isLoading } = useAuthStore();
  const preview = useProfilePreview(user);
  const { pathname, search } = useLocation();
  if (isLoading) return <div role="status" className="p-8">Loading your profile…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (preview && !canOpenProfileRoute(preview, pathname, search)) return <Navigate to={userLanding(preview)} replace />;
  if (!canOpenProfileRoute(user, pathname, search)) return <NoAccessPage />;
  return <>{children}</>;
}
